<template>
  <div class="menu-header">
    <div
      class="menu-header__icon-container"
      @click="onCollapseMenu(true)"
    >
      <i class="menu-header__icon-container__icon pi pi-times"></i>
    </div>
    <Divider
      layout="vertical"
      class="menu-header__icon-container__divider"
    />
    <div class="menu-header__text">
      Portal {{ mainText }}
    </div>
  </div>
</template>

<script setup>
// #region VUE
import {computed} from 'vue';
import {useStore} from 'vuex';
// #endregion

// #region COMPONENTS COMPOSABLES
import Divider from 'primevue/divider/sfc';
// #endregion

// #region Props, Emits
const emit = defineEmits(['collapse']);
// #endregion

// #region Params, Ref, Reactives, Computed
const store = useStore();
const mainText = computed(() => store.getters['text/getSectionTexts']('main'));
// #endregion

// #region Functions
function onCollapseMenu(collapse) {
  emit('collapse', collapse);
}
// #endregion
</script>

<style lang="scss" scoped>
@use '@/styles/vars' as *;
@use '@/styles/breakpoints' as *;

.menu-header {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;

  &__icon-container {
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    margin: 0 $brand__boxspace--medium 0 ($brand__boxspace--medium * 2);

    &__divider {
      min-height: 65% !important;
    }

    &__icon {
      font-size: ($pv__fs--medium * 2);
      color: $pv__color--white;
      -webkit-transition: all .5s ease;
      -o-transition: all .5s ease;
      transition: all .5s ease;
      border-radius: 50%;
    }

    &__icon:hover {
      background-color: rgba(255, 255, 255, .25);
      -webkit-transform-origin: center center;
      -ms-transform-origin: center center;
      transform-origin: center center;
      -webkit-transform: rotate(90deg);
      -ms-transform: rotate(90deg);
      transform: rotate(90deg);
      outline: inset thick #fff;
    }
  }

  &__text {
    color: $pv__color--white;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    font-size: $pv__fs--xlarge;
    margin: 0 0 0 ($brand__boxspace--medium);
  }
}
</style>
